import { Injectable } from '@angular/core';
import { ConfigResource } from '@df/catalog/config//config.resource';
import { Acl } from '@df/core/service/acl';
import { TimeoutService } from '@df/ng/timeout.service';
import { App } from '@df/core/app';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { Subscription, merge } from 'rxjs';
import { NMarkerIO } from './marker-io.namespace';

declare global {
    interface Window {
        Marker?: NMarkerIO.IMarker;
        __Marker: Record<string, never>;
    }
}

declare module '@df/core/df-core.config' {
    export interface IDfConfig {
        marker_IO?: NMarkerIO.IConfig;
    }
}

ICmsContentService.registerConfig({
    id: NMarkerIO.configUrl,
    name: 'MarkerIO',
    fields: [
        {
            key: 'project',
            type: NICmsContentField.EFieldType.text,
            title: 'Project ID',
            required: true
        }
    ]
});

@Injectable({ providedIn: 'root' })
export class MarkerIO {
    private subscription = new Subscription();
    constructor(
        private app: App,
        private acl: Acl,
        private timeoutService: TimeoutService,
        private configResource: ConfigResource
    ) {
        if (this.app.isPlatformBrowser && !acl.isDeveloper) {
            this.subscription = merge(this.acl.authStatus, this.app.client.isCms$).subscribe(() => this.update());
        }
    }

    private loadScript = this.timeoutService.debounce(() => {
        if (!window.__Marker) {
            ((e, r, a) => {
                if (!e.__Marker) {
                    e.__Marker = {};
                    const t: any[] = [],
                        n = { __cs: t, show: () => {}, hide: () => {} };
                    [
                        'show',
                        'hide',
                        'isVisible',
                        'capture',
                        'cancelCapture',
                        'unload',
                        'reload',
                        'isExtensionInstalled',
                        'setReporter',
                        'setCustomData',
                        'on',
                        'off'
                    ].forEach(e => {
                        n[e] = (...a) => {
                            const r = Array.prototype.slice.call(a);
                            r.unshift(e), t.push(r);
                        };
                    }),
                        (e.Marker = n);
                    const s = r.createElement('script');
                    (s.async = true), (s.src = 'https://edge.marker.io/latest/shim.js');
                    const i = r.getElementsByTagName('script')[0];
                    i.parentNode?.insertBefore(s, i);
                }
            })(window, document);
        }
    }, 2000);

    private async update(): Promise<void> {
        if (this.canShow) {
            if (window.Marker) {
                window.Marker.show();
            } else {
                const config = await this.configResource.loadModelByUrl(NMarkerIO.configUrl);
                const project = config?.data?.content?.project;
                if (!project) {
                    this.subscription.unsubscribe();
                    return;
                }
                window['markerConfig'] = {
                    project,
                    source: 'snippet'
                };
                this.loadScript();
            }
        } else {
            window.Marker?.hide();
        }
    }

    private get canShow(): boolean {
        return !this.app.client.isCms$.value && (this.acl.check('cms') || this.app.dfConfig.environment !== 'production');
    }
}
